import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { PaginationFilter } from '@liveauctioneers/caterwaul-components/types/PaginationFilter';
import { Plus } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import styled from 'styled-components';

import SortPageSizePair from '@/components/Pagination/hammer-pagination/SortPageSizePair';
import { savedSearchItemSortOrders } from '@/enums';
import { getSearchBaseUrl } from '@/utils/urls';

type Props = {
    filters: PaginationFilter;
    onFilterChange: (filters: PaginationFilter) => void;
};

const OPTIONS = [
    {
        label: <FormattedMessage id="search_alerts.sort.newlyListed" />,
        value: savedSearchItemSortOrders.NEWLY_LISTED,
    },
    {
        label: <FormattedMessage id="search_alerts.sort.startingSoonest" />,
        value: savedSearchItemSortOrders.STARTING_SOONEST,
    },
];

const SavedSearchNotificationFilter = ({ filters, onFilterChange }: Props) => {
    const newTermUrl = `${getSearchBaseUrl()}?newTerm=true`;

    return (
        <Bar>
            <SortPageSizePair
                hideSort={filters.tab === 'searches'}
                isInsideLabel
                onChange={onFilterChange}
                pageSizeLabelClassName="xsMax:min-w-[50px]"
                paginationFilter={filters}
                sortOptions={OPTIONS}
            />
            <IconText>
                <StyledLink
                    id="search_alerts.placeholder"
                    primaryWeak
                    route
                    to={newTermUrl}
                >
                    <Plus
                        className="mr-xs"
                        size="sm"
                        style="bold"
                    />
                    <Caption
                        color="secondary"
                        data-testid="addNewSearchTerm"
                    >
                        <FormattedMessage id="search_alerts.add_new_search" />
                    </Caption>
                </StyledLink>
            </IconText>
        </Bar>
    );
};

export default SavedSearchNotificationFilter;

const Bar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 32px 0 32px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
`;

const StyledLink = styled(Link)`
    display: inline-flex;
    align-items: center;
`;

const IconText = styled.span`
    &:hover * {
        color: ${({ theme }) => theme.colors.blue200};
    }
`;
